import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import { reaction, observable } from "mobx";
import DataWrapper from '../../principal/containers/DataWrapper';
import {Button, Row, Col, FormGroup, Label, Input} from 'reactstrap';
import Select from 'react-select';
import {TabelaCadastro} from "../components/TabelaCadastro";
import NumberFormat from "react-number-format";
import GrupoNGFTStore from "../stores/GrupoNGFTStore";
import {arrayToString, createSelectOptions} from "../../../utils/formatar";
import {Validacao} from "../../comum/components/Validacao";
import FontAwesome from 'react-fontawesome';

@inject("store")
@DataWrapper
@observer
export class CadastroGrupoNGFT extends Component {
    constructor(props) {
        super(props);
        this.modal                      = this.props.store.modalStore;
        this.appStore                   = this.props.store.appStore;
        this.tituloPaginaStore          = this.props.store.tituloPaginaStore;
        this.controller                 = new GrupoNGFTStore(this.modal);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Grupo NGFT");

        this.controller.carregarLista();
    }

    removePosicao(value){
        this.controller.removePosicaoValue(value);
    }

    renderizarPosicoesSelecionadas(){
        const posicoes = this.controller.posicoesSelecionadas != undefined ? this.controller.posicoesSelecionadas : [];
        return <Col xs={12} md={12} lg={12}>
            <Label>Posições <sup>*</sup></Label>
            {
                posicoes.map(
                (pos, i) =>
                    <FormGroup Key={i}>
                        <div>
                            <div className="history-item" style={{width: "85%", float: "left"}}>
                                {pos}
                            </div>
                            <div style={{float: "left", marginLeft: "10px", marginTop: "3px" }} onClick={() => this.removePosicao(pos)}><FontAwesome name="minus-circle" size="2x"/></div>
                        </div>
                    </FormGroup>
                )
            }
            <Validacao id="posicoesSelecionadas" valor={this.controller.posicoesSelecionadas} tipo={["isRequired","quantidadeMin", 1]} />
        </Col>;
    }

    /* modais (body e botões) */
    modalForm = () => {
        const usuarioCacheOptions = createSelectOptions(this.controller.itemSelecionado.usuarios, "login", "nome");
        const empregadoOptions = createSelectOptions(this.controller.empregados, "cpf", "nome");
        return(
            <Row>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup check >
                        <Label check>
                            <Input type="checkbox" checked={this.controller.itemSelecionado.ativo} onChange={() => this.controller.toggleAtivo()} />{' '}
                            <Label>Ativo</Label>
                        </Label>
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Nome <sup>*</sup></Label>
                        <Input type="text" maxLength={64} value={this.controller.itemSelecionado.nome} onChange={(event) => this.controller.setNome(event.target.value)} />
                        <Validacao id="nome" valor={this.controller.itemSelecionado.nome} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Membros <sup>*</sup></Label>
                        <Select simpleValue cacheAsyncResults={false}  options={usuarioCacheOptions} value={this.controller.itemSelecionado.usuarioLogins}
                                onChange={(value) => this.controller.setUsuarioLogin(value)}
                                searchPromptText="Informe nome para pesquisar" noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                asyncOptions={(input, callback) => this.controller.filtrarUsuarios(input, callback)} multi="true" />
                        <Validacao id="usuarioLogins" valor={this.controller.itemSelecionado.usuarioLogins} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Avaliar solicitações para posições abaixo de</Label>
                        <Select searchPromptText="Informe CPF ou matrícula para pesquisar"
                                noResultsText={"Empregado não encontrado ou já associado"}
                                placeholder="Selecione..."
                                value={this.controller.itemSelecionado.empregadoCPFs}
                                onChange={(value) => this.controller.setEmpregadoCPF(value)}
                                asyncOptions={(input, callback) => this.controller.filtrarEmpregados(input, callback)} multi/>
                        {(this.controller.alerta.length > 0) && <span style={{color: 'red', display: 'block'}}>{this.controller.alerta}</span> }
                    </FormGroup>
                </Col>
                { this.renderizarPosicoesSelecionadas() }
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Descrição</Label>
                        <Input type="textarea" maxLength={512} value={this.controller.itemSelecionado.descricao} onChange={(event) => this.controller.setDescricao(event.target.value)} />
                    </FormGroup>
                </Col>
            </Row>
        )
    };

    obterTituloMobile = (objeto) => {
        return objeto.nome;
    };

    obterConteudoMobile = (objeto) => {
        const ativo = objeto.ativo ? "Sim" : "Não"
        return (
            <div>
                { objeto.descricao ? "Descrição: " + objeto.descricao : null}<br/>
                { "Avaliar solicitações para posições abaixo de: " + arrayToString(objeto.empregados, "nome")}<br/>
                { "Membros: " + arrayToString(objeto.usuarios, "nome")}<br/>
                { "Ativo: " + ativo}<br/>
            </div>
        )
    };

    nomesFormat(cell) {
        return cell ? arrayToString(cell, "nome") : ""
    }

    posicoesFormat(cell) {
        return cell ? arrayToString(cell, "posicao") : ""
    }

    render() {
        /* Colunas da TabelaStore */
        const colunas = [
            {
                field: "nome",
                label: "Nome"
            },{
                field: "descricao",
                label: "Descrição"
            },{
                field: "posicoes",
                label: "Avaliar solicitações para posições abaixo de",
                dataFormat: this.posicoesFormat
            },{
                field: "usuarios",
                label: "Membros",
                dataFormat: this.nomesFormat
            },{
                field: "ativo",
                label: "Ativo",
                type: "boolean"
            }
        ];

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel panel-sm" : "panel-sm"}>
                        <TabelaCadastro
                            nomeCadastro={'Grupo NGFT'}
                            onChange={(value) => this.controller.setLista(value)}
                            listaItens={this.controller.grupoNGFTList}
                            colunas={colunas}
                            temBusca={true}
                            criarNovos={true}
                            modalEditar={this.modalForm()}
                            modalCadastrar={this.modalForm()}
                            preencherModal={(row) => this.controller.preencherModal(row)}
                            editar={() => this.controller.editar()}
                            cadastrar={() => this.controller.cadastrar()}
                            remover={() => this.controller.remover()}
                            tituloMobile={(row) => this.obterTituloMobile(row)}
                            conteudoMobile={(row) => this.obterConteudoMobile(row)}
                            loading={this.controller.loading}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

